// extracted by mini-css-extract-plugin
export default {"line-chart":"CopyStatisticsChart_line-chart__WaWgF","title-chart":"CopyStatisticsChart_title-chart__5Z6zH","img-line-chart":"CopyStatisticsChart_img-line-chart__UJ7fD"};